/**
 * Formats a Date object to "h:mm am/pm" format (lowercase am/pm with space)
 *
 * @param date - Date object to format
 * @returns Formatted time string (e.g., "2:30 pm", "12:00 am")
 *
 * @example
 * formatTime(new Date(2024, 2, 15, 14, 30)) // Returns "2:30 pm"
 * formatTime(new Date(2024, 2, 15, 0, 0)) // Returns "12:00 am"
 * formatTime(new Date(2024, 2, 15, 12, 0)) // Returns "12:00 pm"
 */
export function formatTime(date: Date): string {
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const period = hours >= 12 ? 'pm' : 'am';
  const displayHours = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
  const displayMinutes = minutes.toString().padStart(2, '0');

  return `${displayHours}:${displayMinutes} ${period}`;
}
